<template lang="pug">
  .b-project-desc-aside(v-if="project")
    ._title Данные проекта
      template(v-if="objectType")
        ._hr
        ._info-title1 Тип помещения:
        ._info-value1 {{ objectType }}
      template(v-if="objectInfo.length")
        ._hr
        ._object-info
          template(v-for="item in objectInfo")
            ._info-title2 {{ item.title }}
            ._info-value2 {{ item.value }}
      template(v-if="project.objectAddress")
        ._hr
        ._info-title1 Адрес:
        ._info-value1 {{ project.objectAddress }}
      template(v-if="projectInfo.length")
        ._hr
        ._object-info
          template(v-for="item in projectInfo")
            ._info-title2 {{ item.title }}
            ._info-value2 {{ item.value }}
</template>

<script>
import utils from '@/utils/common';

export default {
  name: 'ProjectDescriptionAside',
  props: {
    project: Object,
  },
  data() {
    return {
      stats: [],
    };
  },

  computed: {
    objectType() {
      switch (this.project.objectType) {
        case 'apartment':   return 'Квартира';                    // eslint-disable-line
        case 'flat':        return 'Многоквартирный дом';         // eslint-disable-line
        case 'house':       return 'Частный дом';                 // eslint-disable-line
        case 'social':      return 'Социальный объект';           // eslint-disable-line
        case 'commercial':  return 'Коммерческая недвижимость';   // eslint-disable-line
        case 'other':       return 'Другое';                      // eslint-disable-line
        default:            return '';                            // eslint-disable-line
      }
    },
    objectInfo() {
      return [
        { title: 'Площадь, м²',           value: this.project.objectArea },           // eslint-disable-line
        { title: 'руб/м²',                value: this.project.pricePerSquareMeter },  // eslint-disable-line
        { title: 'Этажей',                value: this.project.objectFloorsQty },      // eslint-disable-line
        { title: 'Количество комнат',     value: this.project.objectRoomsQty },       // eslint-disable-line
      ].filter(o => o.value);
    },
    projectInfo() {
      return [
        { title: 'Объем проекта',    value: utils.fileSize(this.project.sizeOfFiles).string },  // eslint-disable-line
        { title: 'Кол-во папок',     value: this.project.numberOfCategories                 },  // eslint-disable-line
        { title: 'Кол-во файлов',    value: this.project.numberOfFiles                      },  // eslint-disable-line
        { title: 'Кол-во разделов',  value: this.project.numberOfStages                     },   // eslint-disable-line
        { title: 'Всего задач',      value: this.project.numberOfTasks                      },   // eslint-disable-line
        { title: 'Открытых задач',   value: this.project.numberOfOpenedTasks                },   // eslint-disable-line
        { title: 'Закрытых задач',   value: this.project.numberOfClosedTasks                },   // eslint-disable-line
      ];
    },
  },
};
</script>

<style lang="scss">
.project-desc-aside {
  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #232226;
  }


  &__hr {
    margin: 20px 0;
    height: 1px;
    width: 100%;
    background: #EBEFF2;
  }

  &__object-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    align-items: center;
    width: 100%;
  }

  &__info-title1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0.01em;
    margin-bottom: 14px;
    color: #92A0B0;
  }

  &__info-title2 {
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0.01em;
    color: #92A0B0;
    margin: 7px 0;
  }

  &__info-value1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    padding: 6px 11px;
    background: #F5F7F9;
    border-radius: 10px;
  }

  &__info-value2 {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    justify-self: end;
  }

}
</style>
